import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { brandsApi } from '@/features/brands/api';
import { queryKeys } from '@/lib/api/queryKeys';
import { Breadcrumbs } from '@/components/ui/Breadcrumbs';
import { useT } from '@/lib/i18n/useT';
import { XotskisTab } from './XotskisTab';

/**
 * Standalone Xotskies catalog for a single brand.
 *
 * Renders the SAME surface as the brand profile's "Xotskies" tab, but on its
 * own page — so the sidebar's "My Xotskies" entry shows ONLY the catalog
 * (grid + agency adopt section), without the brand hero, KPIs or sibling
 * tabs. Brand-scoped via the `:id` route param; `agencyId` is the parent
 * agency, mirroring how BrandProfilePage wires `<XotskisTab>`.
 */
export function BrandXotskiesPage() {
  const t = useT();
  const { id } = useParams<{ id: string }>();
  const brandId = Number(id);
  const validId = Number.isFinite(brandId) && brandId > 0;

  const brandQ = useQuery({
    queryKey: queryKeys.brands.detail(brandId),
    queryFn: () => brandsApi.get(brandId),
    enabled: validId,
  });
  const brand = brandQ.data ?? null;

  return (
    <div className="page">
      <Breadcrumbs
        className="mb-4"
        items={[
          { label: brand?.name ?? t('breadcrumbs.brand'), to: `/brand/${brandId}` },
          { label: t('sidebar.myXotskies') },
        ]}
      />
      <XotskisTab
        brandId={validId ? brandId : null}
        agencyId={brand?.parentId ?? null}
      />
    </div>
  );
}
